// extracted by mini-css-extract-plugin
module.exports = {"alert_card_close":"AlertClose_alert_card_close__3NdVP","bigger_title":"AlertClose_bigger_title__S2upi"};